import { render, staticRenderFns } from "./KitMetricCard.vue?vue&type=template&id=d99c033a"
import script from "./KitMetricCard.vue?vue&type=script&lang=ts"
export * from "./KitMetricCard.vue?vue&type=script&lang=ts"
import style0 from "./KitMetricCard.vue?vue&type=style&index=0&id=d99c033a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports